import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "box forms" }
const _hoisted_2 = {
  class: "columns",
  role: "form",
  "aria-label": "Input para recebimento de tarefas"
}
const _hoisted_3 = { class: "column is-8" }
const _hoisted_4 = ["placeholder"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Timer = _resolveComponent("Timer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "input form-input",
          placeholder: _ctx.placeholder,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.descriptionTask) = $event))
        }, null, 8, _hoisted_4), [
          [_vModelText, _ctx.descriptionTask]
        ])
      ]),
      _createVNode(_component_Timer, { onFinishedTimer: _ctx.endTask }, null, 8, ["onFinishedTimer"])
    ])
  ]))
}